import { render, staticRenderFns } from "./DsGeneralAndMonthlyResults.vue?vue&type=template&id=0a642c63&scoped=true"
import script from "./DsGeneralAndMonthlyResults.vue?vue&type=script&lang=js"
export * from "./DsGeneralAndMonthlyResults.vue?vue&type=script&lang=js"
import style0 from "./DsGeneralAndMonthlyResults.vue?vue&type=style&index=0&id=0a642c63&prod&scoped=true&lang=scss"
import style1 from "./DsGeneralAndMonthlyResults.vue?vue&type=style&index=1&id=0a642c63&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a642c63",
  null
  
)

export default component.exports